module.exports = __webpack_public_path__ + "img/icon-money-send.f2636288.svg";